import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface AlertDialogButton {
  label: string;
  url: string;
  newTab?: boolean; // true for new tab, false for same tab
}

export interface AlertDialogData {
  message: string;
  closeButton?: string;
  buttons?: AlertDialogButton[];
}

@Component({
  selector: 'app-alert-dialog',
  templateUrl: './alert-dialog.component.html',
  styleUrls: ['./alert-dialog.component.css']
})
export class AlertDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: AlertDialogData) {
    if (this.data.closeButton === '') {
      this.data.closeButton = null; // No close button
    } else if (!this.data.closeButton) {
      this.data.closeButton = 'OK'; // Default value
    }
  }

  openUrl(url: string, newTab: boolean = true) {
      window.open(url, newTab ? '_blank':'_self');
  }
}